export const fetchData = async (token, url) => {
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': token },
        })

        const data = await response.json();
        return data;
    } catch (err) {
        console.error('Error fetching data:', err);
        console.log(err);
    }
}